<script>
import DidoDatafile from "./components/Datafile.vue";

export default {
  name: "DidoDatafileCe",
  components: {
    DidoDatafile,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoDatafileRid: { type: String, required: true },
    didoDatafileMillesime: { type: String, default: void 0 },
    didoInitialFilter: { type: String, required: false, default: null },
  },
  emits: [
    "datafile-retrieved",
    "datafile-not-retrieved",
    "label-selection",
    "dataset-selection",
    "millesime-selection",
    "bad-configuration",
  ],
  template: `
    <DidoDatafile
      :api-url="didoUrl"
      :datafile-rid="didoDatafileRid"
      :datafile-millesime="didoDatafileMillesime"
      :initial-filter="didoInitialFilter"
      @datafile-retrieved="$emit('datafile-retrieved', $event)"
      @datafile-not-retrieved="$emit('datafile-not-retrieved', $event)"
      @label-selection="$emit('label-selection', $event)"
      @dataset-selection="$emit('dataset-selection', $event)"
      @millesime-selection="$emit('millesime-selection', $event)"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
